export default __webpack_public_path__ + "static/britannica-c4e6d64cbc54626445abe1ac2b33da98.svg";